import { useEffect, useState } from "react";
import { wvusLogger } from "../../helpers";

type ScreensConfig = {
  [key: string]: string;
};

const firstKey = (obj: ScreensConfig) => (obj && Object.keys(obj)[0]) || "";

const defaultScreensConfig: ScreensConfig = {
  "x-small": "(max-width: 479px)", // firstKey is the defaultScreen
  small: "(max-width: 767px) and (min-width: 480px)",
  medium: "(max-width: 1199px) and (min-width: 768px)",
  large: "(min-width: 1200px)"
};

const getInitialMatch = (screensConfig: ScreensConfig, defaultScreen: string): string => {
  for (const [screen, mQuery] of Object.entries(screensConfig)) {
    if (window.matchMedia(mQuery).matches) {
      return screen;
    }
  }

  return defaultScreen;
};

export default function useMediaQuery(
  screensConfig = defaultScreensConfig,
  defaultScreen: string = firstKey(screensConfig)
) {
  const [deviceScreen, setDeviceScreen] = useState(getInitialMatch(screensConfig, defaultScreen));
  const setListener = (screen: string, mquery: string) => () => {
    if (window.matchMedia(mquery).matches) {
      setDeviceScreen(screen);
    }
  };

  useEffect(() => {
    const listeners = {};
    const mqls = {};

    for (const [screen, mQuery] of Object.entries(screensConfig)) {
      listeners[screen] = setListener(screen, mQuery);
      mqls[screen] = window.matchMedia(mQuery);
      mqls[screen].addListener(listeners[screen]);
    }

    return () => {
      try {
        // Clean Up
        for (const key of Object.keys(mqls)) {
          mqls[key].removeListener(listeners[key]);
        }
      } catch (err) {
        wvusLogger.log(err, "error");
      }
    };
  }, [screensConfig]);

  return {
    deviceScreen,
    deviceScreens: screensConfig
  };
}
